module.exports = __webpack_public_path__ + "static/media/cam.4d188a01.png";